import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/InstitutionReports'
import context from '@/context'
import { Main, MainBody, MainTop, MainTopTitle, WhiteBox } from '@/components/Layout'
import { Row, Col } from 'reactstrap'
import Resx from '@/components/Resx'
import { localized } from '@/decorators/localized'
import ReportAttachments from '@/components/reporting/reportAttachments'
import ReportSubmissionComments from '@/components/reporting/reportSubmissionComments'
import LoadingIndicator from '@/components/LoadingIndicator'
import Name from '@/components/Name'
import ErrorButton from '@/components/ErrorButton'
import ErrorBoundary from '@/components/ErrorBoundary'
import { InstitutionReportTable } from './institutionReportTable'
import { ReportSubmissionTitle } from '@/components/reporting/submissions/reportSubmissionTitle'
import { InfoContent, InfoLabel, InfoRow } from '@/components/InfoRow'
import { ReportSubmissionGroupNotes } from '@/components/reporting/reportSubmissionGroupNotes'

@localized()
class InstitutionReportDetail extends React.Component {
  constructor (props) {
    super(props)
    this.getParentId = this.getParentId.bind(this)
    this.goBack = this.goBack.bind(this)
  }

  getReportId () {
    return this.props.match.params.id
  }
  getParentId () {
    return this.props.match.params.parentId
  }
  getBackUrl () {
    return `/${'icbs-report-groups'}/${this.getParentId()}/icbs-reports`
  }
  goBack () {
    const url = this.getBackUrl()
    this.props.history.push(url)
  }
  componentDidMount () {
    this.reload()
  }
  componentDidUpdate (prevProps, prevState) {
    if (this.getReportId() !== prevProps.match.params.id) {
      this.reload()
    }
  }
  reload () {
    this.props.get(this.getReportId(), this.getParentId())
  }

  renderGeneralBox (institutionReport) {
    if (institutionReport === null) {
      return (
        <WhiteBox backUrl='/' header={<Resx name='Reporting.General' />}>
          <ErrorButton className='white-box-center' onClick={() => this.reload()} />
        </WhiteBox>
      )
    }

    return (
      <WhiteBox header='Reporting.General'>
        <Row>
          <Col sm='6'>
            <InfoRow>
              <InfoLabel><Resx name='Common.Name' /></InfoLabel>
              <InfoContent><Name data={institutionReport} /></InfoContent>
            </InfoRow>
            <InfoRow>
              <InfoLabel><Resx name='Reporting.ReportTemplateName' /></InfoLabel>
              <InfoContent><Name data={institutionReport.reportTemplateVersion} /></InfoContent>
            </InfoRow>
          </Col>
        </Row>
      </WhiteBox>
    )
  }
  renderBody () {
    const { institutionReports, addAttachments, removeAttachments } = this.props

    if (institutionReports.fetching === true) { return (<LoadingIndicator />) }
    const submissionId = this.getReportId()
    return (
      <React.Fragment>
        <WhiteBox>
          <Row>
            <Col sm='12'>
              <ErrorBoundary>
                <Resx render={(x) => <InstitutionReportTable
                  isRtl={x.rtl}
                  isLoading={institutionReports.fetching}
                  institutionReport={institutionReports.institutionReport}
                  cellMetadata={institutionReports.cellMetadata}
                  sourceHeaders={institutionReports.sourceHeaders}
                  sourceRowHeaders={institutionReports.sourceRowHeaders}
                  sourceData={institutionReports.sourceData}
                  key={institutionReports.key}
                  readOnly />}
                />
              </ErrorBoundary>
            </Col>
          </Row>
        </WhiteBox>
        <Row>
          <Col sm='12'>
            <ErrorBoundary>
              <ReportAttachments
                key={institutionReports.attachmentsKey}
                dataSource={() => context.api.institutionReportService.getAttachments(submissionId)}
                downloadAction={context.api.institutionReportService.download}
                parentId={submissionId}
                addAttachments={addAttachments}
                removeAttachment={id => removeAttachments({ entityId: submissionId, fileIds: [id] })}
                adding={institutionReports.adding} />
            </ErrorBoundary>
          </Col>
        </Row>
        <Row>
          <Col sm='12'>
            <ErrorBoundary>
              <ReportSubmissionComments showExternalVisibilityCheckbox parentId={submissionId} disabled={false} />
            </ErrorBoundary>
          </Col>
        </Row>
      </React.Fragment>
    )
  }
  render () {
    const { institutionReports } = this.props
    if (institutionReports.fetching === true) { return (<LoadingIndicator />) }
    const institutionReport = institutionReports.institutionReport || {}

    return (
      <Main>
        <MainTop>
          <MainTopTitle backUrl={this.getBackUrl()}>
            <Resx name='Reporting.InstitutionReportDetailTitle' /> <ReportSubmissionTitle reportSubmission={this.props.institutionReports.institutionReport} />
          </MainTopTitle>
        </MainTop>
        {this.renderGeneralBox(institutionReports.institutionReport)}
        <ReportSubmissionGroupNotes reportSubmission={institutionReport.institutionReport || {}} />
        <MainBody transparent>
          {this.renderBody()}
        </MainBody>
      </Main>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    institutionReports: state.institutionReports,
    ...ownProps
  }
}

const mapDispatchToProps = {
  get: actionCreators.get,
  addAttachments: actionCreators.addAttachments,
  removeAttachments: actionCreators.removeAttachments
}

export default connect(mapStateToProps, mapDispatchToProps)(InstitutionReportDetail)



// WEBPACK FOOTER //
// ./src/internal-app/pages/institutionReports/institutionReportDetail.js